import { defineAsyncComponent } from 'vue';

const TableFilterTracking = defineAsyncComponent(() => import('./TableFilterTracking.vue'));

export default TableFilterTracking;